import { Flex, HStack, IconButton, Text } from '@chakra-ui/react';
import { useGraduateModal } from '@ui/components/GraduateModal/useGraduateModal';
import { MaskIcon } from '@ui/components/MaskIcon';
import SkeletonOrText from '@ui/components/SkeletonOrText';
import { useGraduatedTokens } from '@ui/hooks/useGraduatedTokens';
import React, { useState } from 'react';

export const GraduationBanner = () => {
  const { data: graduatedTokens } = useGraduatedTokens();
  const hasOneGraduatedToken = graduatedTokens?.length === 1;
  const hasGraduatedTokens = (graduatedTokens?.length ?? 0) >= 1;
  const openModal = useGraduateModal((s) => s.openModal);
  const [isClosed, setIsClosed] = useState(false);
  if (!hasGraduatedTokens || isClosed) return null;

  const handleClick = () =>
    openModal(graduatedTokens?.[0]?.bonding_token_address ?? '');

  const graduationMessage = hasOneGraduatedToken ? (
    <>
      Agent{' '}
      <SkeletonOrText>{graduatedTokens[0]?.bonding_token_name}</SkeletonOrText>{' '}
      (
      <SkeletonOrText>
        {graduatedTokens[0]?.bonding_token_symbol}
      </SkeletonOrText>
      ) is ready to graduate
    </>
  ) : (
    `${graduatedTokens?.length} agents are ready to graduate`
  );

  return (
    <Flex
      p={{ base: '4px 20px', desktop: '4px 155px' }}
      position="absolute"
      top="100%"
      w="100%"
      bg="background.rose"
      textStyle="caption"
      alignItems="center"
      onClick={handleClick}
      cursor="pointer"
    >
      <HStack justify="space-between" w="100%">
        <Text textDecoration="underline" lineClamp={1} wordBreak="break-all">
          {graduationMessage}
        </Text>
        <IconButton
          onClick={(e) => {
            setIsClosed(true);
            e.stopPropagation();
          }}
          display="flex"
          alignContent="center"
          aria-label="close"
          cursor="pointer"
          size="xs"
          unstyled
        >
          <MaskIcon icon="url(/masks/close.svg)" boxSize="24px" />
        </IconButton>
      </HStack>
    </Flex>
  );
};
